import { render, staticRenderFns } from "./ProposalVariants.vue?vue&type=template&id=d9e8d2f8&"
import script from "./ProposalVariants.vue?vue&type=script&lang=js&"
export * from "./ProposalVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports